import createItemFetcher from "../helpers/item";
import { createActionDuck } from "../helpers/action";
import { createNotificationOnSaveEpic, createNotificationOnSaveErrorEpic } from "./saveNotification";
export { DatabaseChoice } from "./dbChoice";
function computeItemId(config) {
    return `${config.program}_${config.scenario}`;
}
const computeDBChoicesUrl = ({ program, scenario }) => `/api/v1/${scenario}/${program}/cho`;
export const databaseChoices = createItemFetcher(computeDBChoicesUrl, "DATABASE_CHOICES", computeItemId);
const computeTaskPauseUrl = ({ scenario, program }) => ({
    url: computeDBChoicesUrl({ program, scenario }),
    method: "POST"
});
export const saveDatabaseChoices = createActionDuck("SaveDBChoice", computeTaskPauseUrl, computeItemId);
const saveNotification = createNotificationOnSaveEpic(saveDatabaseChoices.ActionKeys);
const erroNotification = createNotificationOnSaveErrorEpic(saveDatabaseChoices.ActionKeys);
saveDatabaseChoices.middleware.push(saveNotification, erroNotification);
//# sourceMappingURL=index.js.map